import React from 'react';
import { Heading, useColorModeValue, VStack } from '@chakra-ui/react';

function PageHeading({
  mainText,
  subText
}) {
  const subTextColor = useColorModeValue("gray.700", "gray.100");

  return (
    <VStack align="stretch">
      <Heading as="h1" size="xl" textAlign="center">
        {mainText}
      </Heading>
      <Heading as="h2" size="xs" textAlign="center" color={subTextColor} fontWeight="light">
        {subText}
      </Heading>
    </VStack>
  );
}

export default PageHeading;
